import styles from './NavListLink.scss';

import cx from 'classnames';
import React, { useState } from 'react';
import { Link } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLinkV2 } from 'src/components/ContentLinkV2/ContentLinkV2';
import { FlatEntry } from 'src/services/cms/flattenContentful';

export interface NavListLinkProps extends React.HTMLAttributes<HTMLLIElement> {
  link?: FlatEntry<Link>;
  linkClassName?: string;
  closeDrawer?: () => void;
}

export const NavListLink: React.FC<NavListLinkProps> = ({ link, linkClassName, children, className, closeDrawer, ...props }) => {
  if (!link) return null;

  const [isHovered, setHovered] = useState(false);

  return (
    <li className={className} {...props}>
      <ContentLinkV2
        entry={link}
        hideTitle
        className={cx(styles.navListLink, isHovered && styles.navListLinkHover, linkClassName)}
        alwaysRenderChildren
        onMouseOver={() => setHovered(true)}
        onMouseOut={() => setHovered(false)}
        onClick={closeDrawer}
      >
        {children}
      </ContentLinkV2>
    </li>
  );
};

NavListLink.displayName = 'NavListLink';
